import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Phone } from "lucide-react";

const PHONE = "+420 775 659 129";

export default function LegalLayout({ title, lead, children }) {
  return (
    <div className="min-h-screen bg-[#0A0D17] text-slate-200">
      <header className="border-b border-white/10 bg-[#0A0D17]/85 backdrop-blur-xl">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 group" data-testid="legal-logo-link">
            <span
              className="block h-11 w-11 rounded-xl bg-[#0A0D17] ring-1 ring-amber-300/20"
              style={{
                backgroundImage: "url(/brand/logo.png)",
                backgroundRepeat: "no-repeat",
                backgroundSize: "150% auto",
                backgroundPosition: "50% 18%",
              }}
            />
            <div className="leading-tight">
              <div className="font-heading text-base font-bold text-white">STK Komfort</div>
              <div className="text-[10px] uppercase tracking-[0.22em] text-amber-300/80">Znojmo</div>
            </div>
          </Link>
          <a
            href={`tel:${PHONE.replace(/\s+/g, "")}`}
            className="hidden sm:inline-flex items-center gap-2 rounded-lg bg-gradient-to-b from-amber-300 to-amber-500 hover:from-amber-200 hover:to-amber-400 px-4 py-2.5 text-sm font-bold text-slate-900"
            data-testid="legal-call-btn"
          >
            <Phone className="h-4 w-4" />
            {PHONE}
          </a>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-amber-300/80 hover:text-amber-300" data-testid="legal-back-link">
          <ArrowLeft className="h-4 w-4" /> Zpět na úvodní stránku
        </Link>
        <h1 className="font-heading mt-7 text-4xl sm:text-5xl font-extrabold text-white tracking-tight leading-tight">
          {title}
        </h1>
        {lead && (
          <p className="mt-5 text-lg text-slate-400 leading-relaxed max-w-3xl">{lead}</p>
        )}
        <div className="mt-10 prose prose-invert prose-amber max-w-none">
          <div className="text-slate-300 leading-relaxed [&_h2]:font-heading [&_h2]:text-2xl [&_h2]:font-bold [&_h2]:text-white [&_h2]:mt-12 [&_h2]:mb-4 [&_h2]:tracking-tight [&_h3]:font-heading [&_h3]:text-lg [&_h3]:font-semibold [&_h3]:text-amber-200 [&_h3]:mt-8 [&_h3]:mb-3 [&_p]:mb-4 [&_ul]:mb-4 [&_ul]:pl-6 [&_ul]:list-disc [&_ul]:marker:text-amber-300/70 [&_li]:mb-1.5 [&_strong]:text-white [&_a]:text-amber-300 [&_a]:underline [&_a]:underline-offset-2">
            {children}
          </div>
        </div>

        <div className="mt-16 rounded-2xl border border-amber-300/15 bg-white/[0.03] p-6">
          <div className="text-xs uppercase tracking-[0.2em] text-amber-300/80">Kontakt</div>
          <div className="mt-2 text-white font-semibold">Lenka Garguláková</div>
          <div className="mt-1 text-sm">
            Telefon: <a href={`tel:${PHONE.replace(/\s+/g, "")}`} className="text-amber-300 hover:underline">{PHONE}</a>
          </div>
          <div className="mt-1 text-sm">
            E-mail: <a href="mailto:info.stkkomfort@gmail.com" className="text-amber-300 hover:underline">info.stkkomfort@gmail.com</a>
          </div>
          <div className="mt-1 text-sm text-slate-400">Sedlešovice 34, Nový Šaldorf — autoopravna</div>
          <div className="mt-3 text-[11px] text-slate-500">
            Zastřešení projektu: UNOEXTREME Capital Group s.r.o., IČO 09361430. Koncept a zpracování: Charlie Xavier De Acapulco.
          </div>
        </div>
      </main>

      <footer className="border-t border-white/10 bg-[#06080F] py-10">
        <div className="max-w-5xl mx-auto px-6 lg:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs text-slate-500">
          <div className="flex flex-wrap gap-4">
            <Link to="/ochrana-osobnich-udaju" className="hover:text-amber-300">Ochrana osobních údajů</Link>
            <Link to="/cookies" className="hover:text-amber-300">Zásady cookies</Link>
            <Link to="/obchodni-podminky" className="hover:text-amber-300">Obchodní podmínky</Link>
            <Link to="/pravni-pouceni" className="hover:text-amber-300">Právní poučení</Link>
          </div>
          <span>© {new Date().getFullYear()} STK Komfort Znojmo™</span>
        </div>
      </footer>
    </div>
  );
}
